import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'
import { ColumnWidth } from '@app/constants/columnWidth'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { RegistryArchiveListsDataSource } from '../types'

const getOptions = (): Array<Column<RegistryArchiveListsDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(key => !['week'].includes(key)) as Array<
  keyof RegistryArchiveListsDataSource
  >

  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...ColumnWidth
    }
  })
}

export const getColumns = (): Array<Column<RegistryArchiveListsDataSource>> => {
  return getColumnsFromMap<RegistryArchiveListsDataSource>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'week',
        render: (_, { week }) => week && `${week} неделя`
      }
    ]
  })
}
